import React from "react";
import { createRoot } from "react-dom/client";
import {
  BrowserRouter,
  Routes,
  Route,
} from "react-router-dom";
import "./styles/tailwind.css";
import App from "./App";
import AppDetail from "./AppDetail";

const container = document.getElementById("root");
const root = createRoot(container);
root.render(
  <React.StrictMode>
      <BrowserRouter>
        <Routes>
        <Route path="/" element={<App />} />
        <Route path="/:id" element={<AppDetail />} />
        </Routes>
      </BrowserRouter>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
// reportWebVitals();
